import React, { useState, useEffect } from 'react';

interface CustomPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (selectedOption: string) => void;
}

const CustomPopup: React.FC<CustomPopupProps> = ({ isOpen, onClose, onSubmit }) => {
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    if (isOpen) {
      setSelectedOption('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = () => {
    if (selectedOption) {
      onSubmit(selectedOption);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Is this an:
          </label>
          <select
            value={selectedOption}
            onChange={(e) => setSelectedOption(e.target.value)}
            className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-[#456B59]"
          >
            <option value="">Select an option</option>
            <option value="Individual">Individual</option>
            <option value="Advisor">Advisor</option>
            <option value="CPA">CPA</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={!selectedOption}
            className={`px-4 py-2 text-white rounded ${
              !selectedOption ? 'opacity-50 cursor-not-allowed bg-[#3B755E]' : 'bg-[#3B755E] hover:bg-[#2f5d4a]'
            }`}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomPopup;